import { createAsyncThunk } from "@reduxjs/toolkit";
import { type Report } from "../../../domain/entities/report";
import { type ReportsDispatch } from "../../config";
import { type ExtraArgument } from "../../extra-argument";
import { type State } from "../../state";
import { thunkTypes } from "../thunk-types";

export const listQueue = createAsyncThunk<
  Report[],
  string,
  { dispatch: ReportsDispatch; extra: ExtraArgument; state: State }
>(thunkTypes.LIST_QUEUE, async (supervisorId, { extra }) => {
  return await extra.reportsRepo.listQueue(supervisorId);
});
